// extracted by mini-css-extract-plugin
export var orderSummary = "_nz-0";
export var showMoreLessButton = "_nz-1";